"use client";
import { Actions } from "@/components/framework/locationswitcher/locationReducer";
import TheatreButton from "@/components/framework/locationswitcher/TheaterButton";
import ListItem from "@/components/framework/plainlist/ListItem";
import PlainList from "@/components/framework/plainlist/PlainList";
import SuspenseFallback from "@/components/framework/SuspenseFallback";
import Close from "@/components/images/Close";
import DownArrow from "@/components/images/DownArrow";
import RegionTheaters from "@/lib/client/RegionTheaters";
import classNames from "classnames";
import { ActionDispatch, useState } from "react";
import styles from "./RegionOverview.module.css";

//#region [Props]
type RegionOverviewProps = {
    className?: string;
    regionTheaters?: RegionTheaters[];
    dispatch: ActionDispatch<[action: Actions]>;
};
//#endregion

//#region [Component]
export default function RegionOverview({ className, regionTheaters, dispatch }: RegionOverviewProps) {

    return <div className={classNames(styles.RegionInnerContainer, className)}>
        <h2 className={styles.Heading}>Fylkesoversikt over alle bygdekinoer:</h2>
        {!regionTheaters && <SuspenseFallback />}
        {!!regionTheaters && <>
            {regionTheaters.map(region => <RegionExpander key={region.fylkesnavn} region={region} dispatch={dispatch} />)}
        </>}
    </div>;
}
//#endregion

//#region [Component]
type RegionExpanderProps = {
    region: RegionTheaters;
    dispatch: ActionDispatch<[action: Actions]>;
}

function RegionExpander({ region, dispatch }: RegionExpanderProps) {
    const [isOpen, setIsOpen] = useState(false);

    if (region.theaters.length === 0) {
        return null;
    }

    return <div className={classNames(styles.RegionExpander, isOpen ? styles.Open : undefined)}>
        <button onClick={() => setIsOpen(!isOpen)} className={classNames(styles.RegionButton, isOpen ? styles.Open : undefined)}>{region.fylkesnavn}
            {!isOpen && <DownArrow alt={`Vis alle spillesteder i ${region.fylkesnavn}`} className={styles.Down} />}
            {isOpen && <Close theme="dark" className={styles.Close} />}
        </button>
        <PlainList>
            {region.theaters.map(th => <ListItem key={th.teaternr}><TheatreButton theater={th} dispatch={dispatch} /></ListItem>)}
        </PlainList>
    </div>

}
//#endregion
